<template>
  <button
    type="button"
    class="hamb"
  >
    <span class="sr-only">Toggle Menu</span>
    <svg
      class="ham"
      viewBox="0 0 100 100"
    >
      <path
        class="line top"
        d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"
      />
      <path
        class="line middle"
        d="m 30,50 h 40"
      />
      <path
        class="line bottom"
        d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"
      />
    </svg>
  </button>
</template>

<style lang="scss" scoped>
  .hamb {
    @apply block bg-transparent border-0 p-0 relative z-[2];
    @apply xl:hidden;

    .ham {
      @apply cursor-pointer transition-transform duration-300 select-none w-[40px] h-[40px] rounded-full bg-white/15;

      .top {
        stroke-dasharray: 40 160;
      }

      .middle {
        @apply origin-center transition-transform duration-300;

        stroke-dasharray: 25 142;
      }

      .bottom {
        @apply origin-center;

        stroke-dasharray: 40 85;
        transition:
          transform 400ms,
          stroke-dashoffset 400ms;
      }
    }

    .line {
      @apply fill-none stroke-[var(--secondary-color)] stroke-[5];

      stroke-linecap: round;
      transition:
        stroke-dasharray 400ms,
        stroke-dashoffset 400ms,
        stroke 400ms;
    }

    &.active {
      svg {
        @apply rotate-45;

        .top {
          stroke-dashoffset: -64px;
        }

        .middle {
          @apply rotate-90;

          stroke-dasharray: 40 142;
        }

        .bottom {
          stroke-dashoffset: -64px;
        }
      }
    }
  }
</style>
